<template>
    <div>
        <h3 class="form-heading">{{ trans('domain') }}</h3>
        <domain-form v-model="model"></domain-form>

        <h3 class="form-heading">{{ trans('domain_information') }}</h3>
        <div class="row">
            <div class="col-md-6">
                <div id="primaryActions" class="btn-group dropdown" style="text-align:left">
                    <button class="btn-filled btn drop" type="button" v-on:click.stop="checkDomain">Get Domain Info</button>
                    <button class="btn-filled btn dropdown-toggle" type="button" data-toggle="dropdown"><span class="caret"></span></button>
                    <ul class="dropdown-menu">
                        <li><a @click.stop="checkDomain">Query Domain</a></li>
                        <li><a @click.prevent="editNS">Edit Nameservers</a></li>
                        <!--<li><a @click.prevent="editDomain">Edit Domain Contacts</a></li>-->
                        <li><a @click.prevent="renewDomain">Renew Domain</a></li>
                    </ul>
                </div>
            </div>

            <div class="col-md-6">
                <!-- Domain Tools -->
                <div class="dropdown pull-right">
                    <button class="btn btn-primary dropdown-toggle" type="button" id="domain_tools" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                        Domain Tools <span class="caret"></span>
                    </button>
                    <ul class="dropdown-menu" aria-labelledby="domain_tools">
                        <li><a :href="domainTools('whois')" target="_blank">Whois</a></li>
                        <li><a :href="domainTools('mxtoolbox')" target="_blank">MxToolbox</a></li>
                        <li><a :href="domainTools('auda')" target="_blank">auDA</a></li>
                    </ul>
                </div>
            </div>
        </div>

        <span v-if="error" class="alert alert-danger" style="display: block;">{{ error }}</span>

        <!-- Returned HTML -->
        <div class="domain-info emptyHide"></div>

        <!--<div v-if="action != ''">
            <div v-if="action == 'transfer'" class="alert alert-warning" role="alert">The domain is not under our management.</div>
            <div v-if="action == 'manage'" class="alert alert-success" role="alert">The domain is under our control.</div>
            <div v-if="action == 'register'" class="alert alert-success" role="alert">Domain Available. Please Register using the form below.</div>
        </div>-->

        <!--<div id="localRegister" v-if="action == 'manage'">
            <div class="row section">
                <div class="col-md-5">
                    <button type="button" class="btn btn-filled" @click.prevent="renewDomain">Renew Domain</button>
                </div>
                <div class="col-md-7">
                    <button type="button" class="btn btn-default pull-right" @click.prevent="editNS">Edit Nameservers</button>
                    <button type="button" class="btn btn-default pull-right" @click.prevent="editDomain">Edit Domain Contacts</button>
                </div>
            </div>
        </div>-->

        <nameservers :id="id" :updateNS="updateNS"></nameservers>

        <div v-if="model.main_records" style="margin-top: 15px;">
            <h3 class="form-heading">{{ trans('DNS Records') }}</h3>
            <table class="table table-mybordered">
                <tbody>
                <tr>
                    <th>Type</th>
                    <th>Name</th>
                    <th>Content</th>
                </tr>
                <tr v-for="record in model.main_records">
                    <td>{{ record.type }}</td>
                    <td>{{ record.name }}</td>
                    <td>{{ record.content }}</td>
                </tr>
                </tbody>
            </table>
        </div>
        <div v-else>
            <div class="alert alert-warning">No records found in CloudFlare</div>
        </div>

        <!--<domain-registration v-if="action == 'register'" :domain="model"></domain-registration>-->

        <!--<div id="transferDomain" class="section" v-if="action == 'transfer'">
            <h3 class="form-heading">{{ trans('transfer_domain') }}</h3>
            <txt id="domainpw" v-model="model.domainpw" label="Domain Password"></txt>
            <button class="btn btn-primary" @click.prevent="transferDomain">Begin Transfer</button>
        </div>-->
    </div>
</template>

<script>
    export default {
        mixins: [ require('../../methods/domain.js') ],
        props: {
            name: { default: '' },
        },
        data() {
            return {
                id: this.uniqueid(),
                whois: false,
                action: '',
                nameservers: {},
                model: {
                    registrar_id: '0',
                    public_id: '0',
                    company: '',
                    address: '',
                    tld: '',
                    domainpw: '',
                    main_records: false
                },
            }
        },
        created() {
//            this.$eventHub.$on('domainSubmit', this.store);
        },
        computed: {
            getUrl () {
                return this.model.address + '.' + this.model.tld;
            }
        },
        methods: {
            updateNS(nameservers) {
                this.axios.post('/api/domain/updateNS', {
                    registrar_id: this.model.registrar_id,
                    domain: this.model.address,
                    tld: this.model.tld,
                    nameservers: nameservers
                }).then((response) => {
                    let data = response.data;
                    if (typeof data['error'] !== 'undefined') {
                        this.error = data.error;
                    }
                    if (typeof data['success'] !== 'undefined') {
                        this.$eventHub.$emit('nsNotify', this.id, 'success', 'Nameservers have been successfully updated.')
                    }
                }).catch((error) => {
                    fyi(error);
                    fyi(error.response);
                    this.error = 'An undefined error occured';
                });
            },
            domainTools(type) {
                if (type === 'whois') {
                    return 'http://whois.domaintools.com/' + this.getUrl;
                } else if (type === 'mxtoolbox') {
                    return 'http://mxtoolbox.com/SuperTool.aspx?action=mx%3a' + this.getUrl + '&run=toolpage';
                } else if (type === 'auda') {
                    return 'http://admin.auda.org.au/password_recovery/blank_recover_password.jsp?domainName=' + this.getUrl
                }
                return '';
            },
        },
        // It's good to clean up event listeners before a component is destroyed.
        beforeDestroy () {
//                this.$eventHub.$off('domainSubmit', this.store);
        },
        components: {
            'nameservers': require('./nameservers.vue').default,
            'domain-form': require('./domain-form.vue').default,
            'domain-registration': require('./domain-register.vue').default,
            'whois': require('../../view/domain/whois.vue').default
        }
    }
</script>